export default __webpack_public_path__ + "static/media/screen2.5e3b2857.jpg";